import { type FC, useContext } from "react";
import { DragDropEditorContext, type DragDropSettingsProps } from "../../../Forms/DragDrop/DragDropTypes";
import { hasColumnsValue, ReorderableTableSettings } from "../../../Forms/DragDrop/ReorderableTableSettings";

const COLUMN_DEFINITIONS = {
    "current-loyalty": "Current Points",
    "earned"         : "Earned",
    "spent"          : "Spent",
    "before-sale"    : "Before Sale",
    "after-sale"     : "After Sale",
};

export const ReceiptLoyaltyTableSettings: FC<DragDropSettingsProps> = ({
    id,
    value,
}) => {
    const { manager } = useContext(DragDropEditorContext);

    const columns = hasColumnsValue(value) ? value.columns : [];

    return (
        <ReorderableTableSettings
            renameable
            columns={COLUMN_DEFINITIONS}
            value={columns}
            onChange={columns => {
                manager.updateComponent(id, {
                    ...(hasColumnsValue(value) ? value : {}),
                    columns,
                });
            }}
        />
    );
};
